import React from 'react';
import { Star } from 'lucide-react';

export const RatingStars = ({ rating, count, size = 'default', showCount = true, interactive = false, onRate }) => {
  const sizes = {
    sm: 'w-3.5 h-3.5',
    default: 'w-4 h-4',
    lg: 'w-5 h-5',
  };
  
  const starSize = sizes[size] || sizes.default;
  const stars = [1, 2, 3, 4, 5];

  const handleClick = (value) => {
    if (interactive && onRate) {
      onRate(value);
    }
  };

  return (
    <div className="flex items-center gap-1.5">
      <div className="flex items-center gap-0.5">
        {stars.map((star) => (
          <button
            key={star}
            type="button"
            onClick={() => handleClick(star)}
            disabled={!interactive}
            className={`${interactive ? 'cursor-pointer hover:scale-110 transition-transform' : ''}`}
          >
            <Star
              className={`${starSize} ${
                star <= rating
                  ? 'text-secondary fill-secondary'
                  : 'text-muted-foreground/30'
              }`}
            />
          </button>
        ))}
      </div>
      {showCount && count !== undefined && (
        <span className="text-sm text-muted-foreground">
          ({count})
        </span>
      )}
    </div>
  );
};

export default RatingStars;
